import React from "react"

type LayoutAlertsType = {
  platformVersion?: string
}

export const LayoutAlerts: React.FC<LayoutAlertsType> = () => {
  return null
}
